<template>
  <v-container v-if="downloaded">
    <h3>{{ $t('webinars.external-events-title') }}</h3>
    <div class="table-wrapper">
      <table>
        <tr v-for="event in events" :key="event.id">
          <td>
            {{formatDates(event.dateFrom.date, event.dateTo.date, "short")}} <br />
            {{event.time.start}} - {{event.time.end}}{{$calendarConfig.showGMT ? ' GMT+1' : '' }}
          </td>
          <td>
            <strong>{{event.name}}</strong>
          </td>
          <td>
            <strong>{{event.place}}</strong>
          </td>
          <td class="action-column">
            <a class="btn-details" target="_blank" :href="event.eventURL">{{ $t('webinars.details') }}</a>
          </td>
        </tr>
      </table>
    </div>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import { formatDates } from '../../helpers/dates';

  const OWNER_CODE = 'web-webinars-external';

  export default {
    data() {
      return {
        events: [],
      }
    },
    created() {
      this.fetchExternalEvents();
    },
    methods: {
      formatDates,
      async fetchExternalEvents() {
        const API = this.$WEBINARS.config.api;
        try {
          const externalEvents = await axios.get(`${API}/${OWNER_CODE}/events`)
          this.events = await externalEvents.data;
        } catch (e) {
          this.events = [];
        }
      }
    },
    computed: {
      downloaded() {
        return this.events.length > 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  $color-even: #FCFCFC;
  $color-odd:   #FFFFFF;
  $color-border: #D5D6D2;

  .btn-details {
    align-items: center;
    background: #FFFFFF;
    border-radius: 24px;
    border: 2px solid #FF8A00;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    color: #FF8A00;
    display: inline-flex;
    font-family: Ubuntu;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    padding: 11px 39px 13px 39px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  }

  .table-wrapper {
    padding: 30px 0 30px;
    max-height: 400px;
    overflow-y: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  td {
    padding: 14px 17px;

    &.action-column {
      text-align: right;
    }
  }

  tr {
    border-bottom: 1px solid $color-border;
    z-index: 1;
    position: relative;
    transition: all 0.3s ease-in-out;
    background-color: $color-odd;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0);

    &:hover {
      background-color: $color-even;
      z-index: 2;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.15);
    }
  }

  h3 {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    color: #003366;
    margin-top: 24px;
    margin-bottom:0px;
  }

  @media screen and (max-width: 600px) {
    .table-wrapper {
      max-height: 900px;
    }

    table {
      border: 0;
    }

    tr {
      display: block;
      margin-bottom: .625em;
    }

    td {
      border-bottom: 1px solid $color-border;
      display: block;
      font-size: 1em;
      text-align: center;
      padding: 10px 14px;

      &.action-column {
        display: flex;
        justify-content: center;
      }
    }

    table td:last-child {
      border-bottom: 0;
    }
  }
</style>
